document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantes();
  initFaq();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var minis = galeria.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !minis.length) return;

  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-mt-src');
      var srcset = mini.getAttribute('data-mt-srcset');
      if (!src) return;
      principal.src = src;
      if (srcset) principal.srcset = srcset;
      minis.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

function initVariantes() {
  var wrap = document.querySelector('[data-mt-producto]');
  if (!wrap) return;
  var dataEl = wrap.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var botones = wrap.querySelectorAll('[data-mt-valor]');
  var inputId = wrap.querySelector('[data-mt-input-id]');
  var precioActual = wrap.querySelector('[data-mt-precio-actual]');
  var precioTachado = wrap.querySelector('[data-mt-precio-tachado]');
  var btnComprar = wrap.querySelector('[data-mt-btn-comprar]');
  var avisoAgotado = wrap.querySelector('[data-mt-agotado]');

  if (!botones.length) return;

  var seleccion = {};
  wrap.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
    var activo = grupo.querySelector('.mt-seleccionada');
    if (activo) seleccion[grupo.getAttribute('data-mt-opcion')] = activo.getAttribute('data-mt-valor');
  });

  function formatearPrecio(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
    });
  }

  function actualizarImagenVariante(match) {
    if (!match.featured_image) return;
    var galeria = document.querySelector('[data-mt-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    if (!principal) return;
    principal.src = match.featured_image;
    if (match.featured_image_srcset) principal.srcset = match.featured_image_srcset;
    if (match.featured_image_alt) principal.alt = match.featured_image_alt;
    var minis = galeria.querySelectorAll('[data-mt-miniatura]');
    minis.forEach(function (m) {
      var coincide = m.getAttribute('data-mt-src') === match.featured_image;
      m.classList.toggle('mt-activa', coincide);
    });
  }

  function actualizar() {
    var match = variantes.find(function (v) {
      return v.options.every(function (op, i) {
        return seleccion[wrap.querySelectorAll('[data-mt-opcion]')[i].getAttribute('data-mt-opcion')] === op;
      });
    });
    if (!match) return;

    if (inputId) inputId.value = match.id;
    actualizarImagenVariante(match);
    if (precioActual) precioActual.textContent = formatearPrecio(match.price);
    if (precioTachado) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioTachado.textContent = formatearPrecio(match.compare_at_price);
        precioTachado.style.display = '';
      } else {
        precioTachado.style.display = 'none';
      }
    }
    if (btnComprar) {
      btnComprar.disabled = !match.available;
      btnComprar.querySelector('[data-mt-btn-texto]').textContent = match.available
        ? btnComprar.getAttribute('data-mt-texto-disponible')
        : btnComprar.getAttribute('data-mt-texto-agotado');
    }
    if (avisoAgotado) avisoAgotado.style.display = match.available ? 'none' : '';
  }

  botones.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grupo = btn.closest('[data-mt-opcion]');
      grupo.querySelectorAll('[data-mt-valor]').forEach(function (b) { b.classList.remove('mt-seleccionada'); });
      btn.classList.add('mt-seleccionada');
      seleccion[grupo.getAttribute('data-mt-opcion')] = btn.getAttribute('data-mt-valor');
      actualizar();
    });
  });

  actualizar();
}

function initFaq() {
  var items = document.querySelectorAll('[data-mt-faq-item]');
  if (!items.length) return;
  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-mt-faq-pregunta]');
    var respuesta = item.querySelector('[data-mt-faq-respuesta]');
    if (!pregunta || !respuesta) return;
    pregunta.addEventListener('click', function () {
      var abierta = item.classList.contains('mt-abierta');
      items.forEach(function (i) {
        i.classList.remove('mt-abierta');
        i.querySelector('[data-mt-faq-respuesta]').style.maxHeight = null;
      });
      if (!abierta) {
        item.classList.add('mt-abierta');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}
